import React, { Component } from "react";
import { observer } from "mobx-react";

import { Link, Navigate, useParams } from "react-router-dom";
import useStores from "../../../../utils/useStores";

import { Alert } from "../../Component/Alert";
import { ServerErrorPage } from "../../Component/ServerErrorPage";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import SidebarObject from "../../Component/SidebarObject";
import Paper from "@mui/material/Paper";

import StatBox from "./StatBox";
import "./style.css";
import { coloredShadow } from "../../assets/jss/material-kit-pro-react";

const drawerWidth = 240;

class SubjectStats extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            error: "",
            newObjectModalIsOpen: false,
            editObjectModalIsOpen: false,
            updateComponent: 0,
            publicWarning: false,
            redirectToNewSlug: undefined
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.subject = this.subject.bind(this);
        this.togglePublic = this.togglePublic.bind(this);
    }

    componentDidMount() {
        this.fetchSubject();
        this.fetchSubjectScores();
    }

    public render() {
        if (this.state.redirectToNewSlug) {
            let newSubjectSlug = `${this.props.match.params.user}/${this.state.redirectToNewSlug}`;
            return <Navigate to={`/modquiz/subjects/${newSubjectSlug}/settings`} />;
        }

        if (this.props.rootStore.subjectStore.state == "pending") {
            return <CircularProgress color="inherit" />;
        }

        if (this.props.rootStore.subjectStore.state == "error") {
            return <ServerErrorPage />;
        }

        let html: JSX.Element = <div></div>;

        const subject = this.subject();

        const isLoggedIn = this.props.rootStore.profileStore.isLoggedIn;

        if (!subject) return html;

        const quizObjects = Array.from(subject.objects, (x: any) => x[1]);

        return (
            <Grid container direction="row">
                <Grid item xs={"auto"} sm={3} md={2}>
                    <SidebarObject
                        subjectHashKey={subject.hash_key}
                        hasCreateAccess={isLoggedIn}
                        subject={subject}
                        subject_user={subject.user}
                        subject_slug={subject.slug}
                    />
                </Grid>
                <Grid item xs={12} sm={9} md={10}>
                    <Paper className="padding-3" square>
                        <br />
                        <h1>Stats</h1>
                        <br />
                        <br />
                        <div className="SubjectStats"></div>
                        <br />

                        <div className="title-bold">Today</div>
                        <div className="row">
                            <StatBox
                                colWidth={4}
                                title="Percent complete today"
                                data={this.props.rootStore.quizzerStore.quiz_user_subject_tracking.percent_complete_today()}
                                hoverText={this.props.rootStore.quizzerStore.quiz_user_subject_tracking.daily_percent_reset_date}
                                percent={true}
                            />
                            <StatBox
                                colWidth={4}
                                title="Questions left for today"
                                data={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .daily_questions_left
                                }
                                percent={false}
                                hoverText={this.props.rootStore.quizzerStore.quiz_user_subject_tracking.daily_questions_reset_date}
                            />
                        </div>
                        <div className="title-bold">Total</div>
                        <div className="row">
                            <StatBox
                                colWidth={4}
                                title="Total questions to answer today"
                                data={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .daily_questions_total
                                }
                                percent={false}
                                hoverText={this.props.rootStore.quizzerStore.quiz_user_subject_tracking.questions_total_reset_date}

                            />
                            <StatBox
                                colWidth={4}
                                title="Total percent subject complete"
                                data={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .total_completion_percent
                                }
                                percent={true}
                            />
                            <StatBox
                                colWidth={4}
                                title="Total number of questions in subject"
                                data={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .questions_total
                                }
                                percent={false}
                            />
                        </div>
                        <Alert status="error" message={this.state.error} />
                        <br />
                        <h2>Objects</h2>
                        <Link
                            to={`/modquiz/subjects/${this.props.match.params.user}/${this.props.match.params.subject}/stats_atoms`}
                        >
                            Atoms
                        </Link>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Score</th>
                                </tr>
                            </thead>
                            <tbody>
                                {quizObjects.map((quizObject: any) => {
                                    return (
                                        <tr>
                                            <td>{quizObject.title}</td>
                                            <td>
                                                {
                                                    quizObject.tracking
                                                        .quiz_object
                                                }
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Paper>
                </Grid>
            </Grid>
        );
    }

    private fetchSubject() {
        this.props.rootStore.subjectStore.fetchOne(
            this.props.match.params.user,
            this.props.match.params.subject
        );
    }

    private fetchSubjectScores() {
        this.props.rootStore.subjectStore.fetchScores(
            this.props.match.params.user,
            this.props.match.params.subject
        );
    }

    private subjectHashKey() {
        return `${this.props.match.params.user}/${this.props.match.params.subject}`;
    }

    private subject() {
        return this.props.rootStore.subjectStore.subjects.get(
            this.subjectHashKey()
        );
    }

    private togglePublic(ev: any) {
        var subject = this.subject();
        console.log(subject);
        if (!subject.public) {
            subject.public = !subject.public;
            this.props.rootStore.subjectStore.subjects.set(
                this.subjectHashKey(),
                subject
            );
        } else {
            this.setState({
                publicWarning: "Sorry, you can't make a public subject private"
            });
        }
    }

    private onSubmit() {
        var component = this;
        const oldSlug = this.props.match.params.subject;
        this.props.rootStore.subjectStore.subjects
            .get(this.subjectHashKey())
            .save((err: any, newSlug: string) => {
                if (err) {
                    component.setState({
                        error: err.title
                    });
                }
                if (oldSlug !== newSlug) {
                    component.setState({
                        redirectToNewSlug: newSlug
                    });
                }
            });
    }
}

const SubjectStatsRoute = observer(() => {
    const rootStore = useStores();
    const params = useParams<{ user: string; subject: string }>();
    return <SubjectStats rootStore={rootStore} match={{ params }} />;
});

export default SubjectStatsRoute;
